import crud from '@/crud/index/index'
import props from './props'

export default {
  props,
  mixins: [crud]
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/Items/resources/index.js